import { render, staticRenderFns } from "./SysChannelList.vue?vue&type=template&id=5e4381e5&scoped=true&"
import script from "./SysChannelList.vue?vue&type=script&lang=js&"
export * from "./SysChannelList.vue?vue&type=script&lang=js&"
import style0 from "./SysChannelList.vue?vue&type=style&index=0&id=5e4381e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4381e5",
  null
  
)

export default component.exports